<div *ngIf="loading" class="dataLoader"></div>

<ul class="list-group" *ngIf="!loading && !fourEyes" style="overflow-y: scroll;max-height:700px">
  <li style="margin-bottom: 5px;" class="list-group-item" *ngFor="let pk of terms;let i=index">
    {{ pk.termsDescription }}
    <i
      *ngIf="!viewRole"
      (click)="updateTerms(pk.termsCode); clearFileUploader()"
      style="position: absolute;right: 15px;"
      class="mdi md-16 mdi-pencil mb-12 text-info"
    ></i>
    <i
      *ngIf="!viewRole"
      (click)="confirmDeleteModal.show()"
      data-id="{{ pk.termsCode }}"
      style="position: absolute;right: 50px;"
      class="mdi md-16 mdi-trash-can-outline text-danger"
    ></i>
    <div
      bsModal
      #confirmDeleteModal="bs-modal"
      [config]="{backdrop: 'static'}"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myLargeModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title pull-left"></h4>
            <button
              type="button"
              class="close pull-right"
              aria-label="Close"
              (click)="confirmDeleteModal.hide()"
            >
              <span aria-hidden="true"><i class="fa fa-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <h4 style="text-align: center;">{{ visuals.confDel }}</h4>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              (click)="confirmDeleteModal.hide()"
            >
              {{visuals.cancel}}
            </button>
            <button
              type="button"
              class="btn btn-success"
              data-dismiss="modal"
              (click)="checkTerms(pk.termsCode)"
            >
              {{visuals.submit}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </li>
</ul>
<div *ngIf="!loading && !viewRole && !fourEyes" class="text-right" (click)="openNewModal(); termsForm.reset()">
  <i class="mdi md-64 mdi-plus-circle text-primary"></i>
</div>

<ng-container *ngIf="!fourEyes; else simpleForm">
  <div
    bsModal
    #termsModal="bs-modal"
    [config]="{backdrop: 'static'}"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myLargeModalLabel"
    aria-hidden="true"
    *ngIf="!fourEyes"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title pull-left"></h4>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="termsModal.hide(); termsForm.reset()"
          >
            <span aria-hidden="true"><i class="fa fa-close"></i></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="card card-accent-primary shadowed">
            <div class="card-header">
              <strong *ngIf="isUpdating">{{visuals.updateTerms}}</strong>
              <strong *ngIf="!isUpdating">{{visuals.addNewTerms}}</strong>
            </div>
            <div class="card-block">
              <ng-container *ngTemplateOutlet="formContent"></ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #simpleForm>
  <!-- Simple form version without modal styling -->
  <div class="form-container">
    <ng-container *ngTemplateOutlet="formContent"></ng-container>
  </div>
</ng-template>

<ng-template #formContent>
  <form [formGroup]="termsForm" (ngSubmit)="onSubmit()">
    <div class="form-group">
      <label class="input-required" for="name">{{visuals.termsCode}}</label>
      <input
        *ngIf="isUpdating"
        disabled
        [ngClass]="{'errorField':isSubmitted && termsForm.controls['termsCode'].errors?.required}"
        type="text"
        class="form-control"
        formControlName="termsCode"
      />
      <div *ngIf="differences?.termsCode" class="arrow-wrapper">
        <div class="arrow"></div>
        <input
        disabled
        class="form-control"
        type="text"
        [value]="differences?.termsCode?.rightValue"/>
      </div>
      <input
        *ngIf="!isUpdating"
        [ngClass]="{'errorField':isSubmitted && termsForm.controls['termsCode'].errors?.required}"
        type="text"
        class="form-control"
        formControlName="termsCode"
      />
      <div
        class="error"
        *ngIf="isSubmitted && termsForm.controls['termsCode'].errors?.required"
      >
        {{genericVisuals.required}}
      </div>
    </div>
    <div class="form-group">
      <label class="input-required" for="name">{{visuals.termsDesc}}</label>
      <input
        [ngClass]="{'errorField':isSubmitted && termsForm.controls['termsDescription'].errors?.required}"
        type="text"
        class="form-control"
        formControlName="termsDescription"
      />
      <div
        class="error"
        *ngIf="isSubmitted && termsForm.controls['termsDescription'].errors?.required"
      >
        {{genericVisuals.required}}
      </div>
      <div *ngIf="differences?.termsDescription" class="arrow-wrapper">
        <div class="arrow"></div>
        <input
        disabled
        class="form-control"
        type="text"
        [value]="differences?.termsDescription?.rightValue"/>
      </div>
    </div>
    <div *ngIf="(termsForm.controls.filename.value || differences?.filename) && isUpdating" class="row">
      <label class="col-md-12" for="name">{{visuals.termsCurrentFilename}}</label>
      <div class="form-group  col-md-8">
        <input disabled type="text" class="form-control" value="{{ oldFileName }}" />
      </div>
      <div class="form-group  col-md-4">
        <button *ngIf="oldFileBase64" type="button" (click)="downloadFile()" class="btn btn-info">
          {{ visuals.downloadTerms }}
        </button>
      </div>
      <div *ngIf="differences?.filename" class="arrow-wrapper col-md-8">
        <div class="arrow"></div>
        <input disabled type="text" class="form-control" [value]="differences?.filename?.rightValue" />
      </div>
      <div *ngIf="differences?.termsFile" class="arrow-wrapper col-md-3">
        <div class="arrow"></div>
        <button type="button" (click)="downloadFourEyesFile()" class="btn btn-info">
          {{ visuals.downloadTerms }}
        </button>
      </div> 
    </div>
    <div class="row" *ngIf="!fourEyes">
      <label
        *ngIf="isUpdating"
        class="input-required col-md-12"
        for="name"
        >{{visuals.newTerms}}</label
      >
      <label
        *ngIf="!isUpdating"
        class="input-required col-md-12"
        for="name"
        >{{visuals.termsFile}}</label
      >

      <div class="form-group col-md-8">
        <input
          (change)="handleInputChange($event)"
          type="file"
          #inputFile
          class="form-control"
        />
        <div
          class="error"
          *ngIf="isSubmitted && termsForm.controls['termsFile'].errors?.required"
        >
          {{genericVisuals.required}}
        </div>
      </div>
      <div class="form-group col-md-4 " >
        <button type="button" (click)="clearFileUploader()" class="btn btn-info">
          {{ visuals.removeFile }}
        </button>
      </div>
    </div>
    <div style="text-align: center;" *ngIf="!fourEyes">
      <button type="submit" class="btn btn-success">{{ visuals.submit }}</button>
    </div>
  </form>
</ng-template>
<div class="card"  *ngIf="!loading && !fourEyes" >
  <div class="card-header">
    <strong>{{genericVisuals?.requestForApprovalGridTitle}}</strong>
    <a
        href="javascript:void(0);"
        role="button"
        class="pull-right"
        (click)="isCollapsed = !isCollapsed"
      >
        @if (isCollapsed) {
          <i class="fa fa-plus-circle"></i>
        } @else {
          <i class="fa fa-minus-circle"></i>
        }
      </a>
  </div>
  <div class="card-block p-0" [collapse]="isCollapsed">
    <requestsForApproval [selectorName]="tagName"></requestsForApproval>
  </div>
</div>